<template>
  <div>
    <div class="section_title">특정 주제에 대한 분류</div>
    <div class="ll_wraper">
      <LectureCard
        :class="lecture.cls"
        v-bind:lecture="lecture"
        v-bind:key="lecture.id"
        v-for="lecture in lectures"
        @click.native="goDetail(lecture)"
      />
    </div>
    <div class="section_title">로드맵 #107</div>
    <div class="ll_wraper">
      <LectureCard
        :class="lecture.cls"
        v-bind:lecture="lecture"
        v-bind:key="lecture.id"
        v-for="lecture in lectures2"
        @click.native="goDetail(lecture)"
      />
    </div>
  </div>
</template>

<script>
import LectureCard from "@/components/LectureCard";

import * as R from "ramda";

export default {
  components: {
    LectureCard,
  },
  computed: {
    lectures() {
      let lectures = this.$store.state.lectures;

      lectures = R.map((item) => {
        item.cls = item.focus ? "lecturecard_event" : "lecturecard";
        return item;
      }, lectures);

      return lectures;
    },
    lectures2() {
      return this.$store.state.lectures2;
    },
  },

  methods: {
    goDetail(lecture) {
      // this.$store.state.loc = 4;
      this.$router.push({
        path: "/task4",
        query: { mode: "4", lid: lecture.id },
      });
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.section_title {
  color: $gray600;
  font-size: 2em;
  font-family: $font;
  font-weight: 500;
  margin: 45px 0 15px 0;
}
.section_title:nth-child(1) {
  margin: 0 0 15px 0;
}

.ll_wraper {
  flex-grow: 1;
  height: 100%;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 15px;
  column-gap: 15px;

  .lecturecard {
    height: $cardHeight;
    width: 300px;
    // background-color: cyan;
  }
  .lecturecard:hover {
    // opacity: 0.5;
    filter: brightness(90%);
  }

  .lecturecard_event {
    grid-column: 1 / span 2;
    width: 614px;
  }
  //   .lecturecard:nth-child(1) {
  //     grid-column: 1 / span 2;
  //     width: 614px;
  //   }
}
</style>